import { useMap } from 'react-leaflet';
import { useEffect } from 'react';
import * as leaflet from 'leaflet';
import { JourneysItemInterface } from '@interface/journeys';

function ControlFromOutsideCenterMap() {
  const map = useMap();

  function handleCenterByCoordinates(
    dataEvent: CustomEvent<{
      lastLocation: JourneysItemInterface['trucker']['lastLocation'];
    }>,
  ) {
    if (
      dataEvent.detail.lastLocation.coordinates &&
      dataEvent.detail.lastLocation.coordinates.lat &&
      dataEvent.detail.lastLocation.coordinates.lon
    ) {
      map.panTo(
        leaflet.latLng(
          dataEvent.detail.lastLocation.coordinates.lat,
          dataEvent.detail.lastLocation.coordinates.lon,
        ),
        {
          animate: true,
        },
      );
    }
  }

  useEffect(() => {
    window.addEventListener(
      'mapCenterByCoordinates',
      handleCenterByCoordinates,
    );

    return () => {
      window.removeEventListener(
        'mapCenterByCoordinates',
        handleCenterByCoordinates,
      );
    };
  }, []);

  return null;
}

export default ControlFromOutsideCenterMap;
